export default {
  HOME: '/studio/home',
  DASHBOARD: '/studio/dashboard',
  TTS: '/studio/text-to-speech',
  VOICE_CLONING_VOICES: '/studio/voice-cloning/voices',
  VOICE_CLONING_CREATE: '/studio/voice-cloning/create',
  VOICE_CLONING_VOICE_DETAIL: '/studio/voice-cloning/voices/:voiceId',
  PAYMENT: '/studio/payments',
  DUBBING: '/studio/dubbing',
  PAYMENT_HISTORY: '/studio/payment-history',
  SUBSCRIPTION: '/studio/subscription',
  AFFILIATE: '/studio/affiliate',
  AFFILIATE_DETAIL: '/studio/affiliate/detail',
  LIVE_SUPPORT: '/studio/live-support',
  MOBILE_APP: '/studio/mobile-app',
  MANAGE_DEVICE: '/studio/manage-device',
  CONFIG_AUTO_RENEW: '/studio/auto-renewal-payment',
  DUBBING_HOME: '/dubbing/home',
  HOME_DUBBING: '/dubbing',
  PAYMENT_DUBBING: '/dubbing/payments',
  PAYMENT_HISTORY_DUBBING: '/dubbing/payments-history',
  SUBSCRIPTION_DUBBING: '/dubbing/subscription',
  AFFILIATE_DUBBING: '/dubbing/affiliate',
  AFFILIATE_DETAIL_DUBBING: '/dubbing/affiliate/detail',
  DUBBING_PROJECT_DETAIL: '/dubbing/projects/:projectId',
  ERROR: '/error',
  MOBILE: '/m',
  MOBILE_TTS: '/m/text-to-speech',
  MOBILE_REQUESTS: '/m/requests',
  PROJECTS: '/projects',
  PROJECT_DETAIL: '/projects/:projectId',
  REFERRAL: '/studio/referral',
  EARNINGS_MANAGEMENT: '/studio/earnings-management',
  VOICE_LIBRARY: '/studio/voice-library',
  EDUCATORS_HOME: '/educators/home',
  VOICE_LEADERBOARD: '/studio/voice-leaderboard',
  TRANSACTIONS_HISTORY: '/studio/transactions-history',
  REFERRED_ORDERS: '/studio/referred-orders',
  MOBILE_SUBSCRIPTION_SUGGESTION: '/studio/mobile-subscription-suggestion',
  LIST_APPS: '/apps',
  APP_DETAIL: '/apps/:id',
  TOP_PAID_EVENT: '/studio/top-paid-event',
};
